import React, { memo } from 'react';

export interface ReportSettingFromToState {
  from: string;
  to: string;
  isValid: boolean;
}

// Currently FromTo report type only has a ReportDateSetting
// See report-date-setting/FromTo.tsx
function ReportSettingFromTo(): JSX.Element {
  return <></>;
}

export default memo(ReportSettingFromTo);
